module.exports = __webpack_public_path__ + "static/media/Gotham-Book.a523e97d.woff2";